export class TransportStatus {
    // Individual roles
    static NOT_PICKED_UP = 'NOT_PICKED_UP';
    static DROPPED_OFF = 'DROPPED_OFF';
    static PICKED_UP = 'PICKED_UP';

    static ALL_TTRANSPORT_STATUSES = [
        TransportStatus.NOT_PICKED_UP,
        TransportStatus.DROPPED_OFF,
        TransportStatus.PICKED_UP
    ];
  }